import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import routes from './router';
import VueNoty from 'vuejs-noty';
import {library} from '@fortawesome/fontawesome-svg-core';
import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import VueSlideUpDown from 'vue-slide-up-down';
import DotLoader from 'vue-spinner/src/DotLoader.vue';
import VCalendar from 'v-calendar';
import VTooltip from 'v-tooltip'    //https://github.com/Akryum/v-tooltip#usage
import {
    faAlignRight, faTimes, faQuestionCircle, faGlobe,
    faBars, faChartLine, faTruckMoving, faMinusCircle, faPowerOff, faTruckLoading, faHourglassEnd
} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
library.add(faGlobe, faQuestionCircle, faBars, faTimes, faChartLine, faTruckMoving, faAlignRight, faMinusCircle, faPowerOff, faTruckLoading, faHourglassEnd);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(VCalendar);
Vue.use(VTooltip, {
    defaultTrigger: (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? 'click' :'hover',
    defaultOffset: 7,
    defaultDelay: 200,
});
Vue.component('vue-slide-up-down', VueSlideUpDown);
Vue.component('dot-loader', DotLoader);
const router = new VueRouter({routes});
Chart.plugins.register(ChartDataLabels);

Vue.use(VueNoty, {
    timeout: 4000,
    layout: 'bottomRight',
    theme: 'metroui'
});

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
